import React from "react"
import MUIInputAdornment, {
  InputAdornmentProps as MUIInputAdornmentProps,
} from "@mui/material/InputAdornment"
import MUItoMantineInputAdornment from "./mantine/InputAdornment.mantine"

export type InputAdornmentProps =
  | ({ new?: false } & Omit<MUIInputAdornmentProps, "component">)
  | ({ new: true } & Omit<MUIInputAdornmentProps, "component"> & {
        component?: React.FunctionComponent<any>
      })

export const InputAdornment = React.forwardRef<
  HTMLDivElement,
  InputAdornmentProps
>((props, ref) =>
  props.new ? (
    <MUItoMantineInputAdornment {...props} ref={ref} />
  ) : (
    <MUIInputAdornment {...props} ref={ref} />
  ),
)

InputAdornment.displayName = "InputAdornment"

export default InputAdornment
